module.exports = __webpack_public_path__ + "static/media/NoValePortada.117246fc.jpeg";